import React from 'react';
import { Button, Dialog, Box, Typography, Drawer } from '@mui/material';
import { useModals } from '@mattjennings/react-modal-stack';
import Iconify from '@/components//Iconify';
import useMobile from '@/hooks/useMobile';

const MessageDialog = ({
  open,
  onConfirm = () => {},
  onClose = () => {},
  title,
  text,
  acceptLabel,
  blockClose = false,
  icon,
  forceModal = false,
}) => {
  const { closeModal } = useModals();
  const { isMobile } = useMobile();

  if (!open) {
    return null;
  }

  const handleClose = () => {
    if (!blockClose) {
      closeModal();
    }
    onClose();
  };

  const handleAcept = () => {
    closeModal();
    onConfirm();
  };

  const body = (
    <>
      <Box
        sx={{
          mr: 2,
          mt: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          minWidth: isMobile ? '50px' : '380px',
        }}
      >
        <Box
          sx={{
            'width': '20px',
            'height': '20px',
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            '&:hover': {
              cursor: 'pointer',
            },
          }}
          onClick={handleClose}
        >
          <Iconify
            width={16}
            height={16}
            icon={'material-symbols:close'}
            sx={{
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[800]
                  : theme.palette.grey[200],
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          paddingTop: '16px',
          paddingLeft: '32px',
          paddingRight: '32px',
          paddingBottom: '16px',
        }}
      >
        {icon && (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {icon}
          </Box>
        )}
        <Box
          sx={{
            width: '100%',
          }}
        >
          <Typography
            paragraph
            sx={{
              margin: 0,
              padding: 0,
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[900]
                  : theme.palette.grey[100],
              fontSize: '20px',
              fontWeight: 600,
              textAlign: 'center',
            }}
            variant="body2"
          >
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 2,
            width: '100%',
          }}
        >
          <Typography
            paragraph
            sx={{
              margin: 0,
              padding: 0,
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[700]
                  : theme.palette.grey[300],
              mb: 4,
            }}
            variant="body2"
          >
            {text}
          </Typography>
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyItems: 'center',
          }}
        >
          <Button variant="contained" onClick={handleAcept} autoFocus fullWidth>
            {acceptLabel}
          </Button>
        </Box>
      </Box>
    </>
  );

  return (
    <>
      {isMobile && !forceModal ? (
        <Drawer open={open} onClose={handleClose} anchor="bottom">
          {body}
        </Drawer>
      ) : (
        <Dialog open={open} onClose={handleClose} maxWidth="sm">
          {body}
        </Dialog>
      )}
    </>
  );
};

export default MessageDialog;
